import React from 'react'
import { Part } from '../../../types/part/partTypes'
import { fontSizes } from '../../../constants/salesStyles'

interface IProps {
    part: Part
}

const CellDimensionsData = ({ part }: IProps) => {
    // Логика расчета
    const length = part.extraData?.length
    const width = part.extraData?.width
    const height = part.extraData?.height
    const weight = part.extraData?.weight

    const hasDimensions = length && width && height
    const hasWeight = weight

    const calculateVolumetricWeight = (): number => {
        if (!hasDimensions) return 0
        return Math.max(0.1, Math.round(((Number(width) * Number(length) * Number(height)) / 10000 / 5) * 100) / 100)
    }

    const getDimensionsText = (): string => {
        if (hasDimensions) {
            return `${length}x${width}x${height}см`
        }
        return '–'
    }

    const getVolumetricWeightText = (): string => {
        if (hasDimensions) {
            return `${ calculateVolumetricWeight() }кг`
            // return `${Math.max(weight || 0, calculateVolumetricWeight())}кг`
        }
        return '–'
    }

    const getWeightText = (): string => {
        if (hasWeight) {
            return `${weight}кг`
        }
        return '–'
    }

    // Верстка
    const containerStyle = { whiteSpace: 'pre-line' as const, fontSize: fontSizes.xs }

    return <div style={containerStyle}>
        {(hasDimensions && <>
            <div>{getDimensionsText()} </div>
            <div>Вес:{getWeightText()} </div>
            <div>Объемный вес: {getVolumetricWeightText()} </div>
        </>)}
    </div>
}

export default CellDimensionsData

